import React from 'react'

import { useActiveTab } from '@components/hooks/useActiveTab'

import { TeamView } from './TeamView'
import { useRolesTab } from './hooks/useRolesTab'
import { useTeamTab } from './hooks/useTeamTab'

export const TeamContainer = () => {
  const TABS = [
    { label: 'Team', value: 'team' },
    { label: 'Roles', value: 'roles' },
  ]
  const { activeTab, setTabParam } = useActiveTab({
    tabValues: TABS.map((tab) => tab.value),
  })
  const { teamTab } = useTeamTab({
    options: {
      enabled: activeTab === 'team',
    },
  })
  const { rolesTab } = useRolesTab()

  const tabsProps = {
    tabs: TABS,
    activeTab,
    onTabClick: (tab: string) => setTabParam(tab),
  }

  return <TeamView tabsProps={tabsProps} teamTab={teamTab} rolesTab={rolesTab} />
}
